<span [ngClass]="['tooltip__triangle', 'tooltip__triangle_' + arrow]"></span>
<!-- прячет внутреннюю часть тени -->
<span [ngClass]="['tooltip__wall', 'tooltip__wall_' + arrow]"></span>
<div class="tooltip__content">
  <ng-content></ng-content>
</div>